import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { useDisclosure } from '@/hooks';
import { Button, Divider, Modal } from 'antd';

interface Props {
  visible: boolean;
  onClose: VoidFunction;
}

export default function TEFConnectionOverlay(props: Props) {
  const [opened, action] = useDisclosure();

  if (!props.visible) return null;

  return (
    <>
      <ModalLoadingOverlay
        disableLoading
        style={{ borderRadius: 10, textAlign: 'center' }}
        messages={[
          <div style={{ textAlign: 'center' }}>
            <div>
              Inicie o E1 Connect da Elgin antes de solicitar o pagamento no
              pin-pad / Dispositivo TEF.
            </div>
            <Button
              onClick={() => {
                props.onClose();
                action.open();
              }}
            >
              Saiba como!
            </Button>
          </div>,
        ]}
        posAbsolute
      />

      <Modal
        open={opened}
        onCancel={action.close}
        width={700}
        title="Utilização TEF Elgin"
        okButtonProps={{ style: { display: 'none' } }}
        cancelText="Fechar"
      >
        <h3 style={{ marginTop: 0 }}>
          Guia Rápido – Como Usar o TEF Elgin no Ultracar
        </h3>

        <strong>Pré-requisitos para o TEF funcionar</strong>
        <p>Para usar o TEF no Ultracar, verifique se:</p>

        <ul>
          <li>
            Os programas da Elgin estão instalados, abertos e ativos:
            <ul>
              <li>E1_Connect</li>
              <li>TEFHUB (GP Elgin)</li>
            </ul>
          </li>
          <li>
            Ao clicar no relógio do Windows (canto inferior direito), você deve
            visualizar os dois ícones da Elgin.
          </li>
          <li>O pinpad está conectado ao computador e ligado.</li>
          <li>
            O computador está com internet ativa e sem bloqueios de
            firewall/antivírus.
          </li>
        </ul>

        <strong>Verificações rápidas</strong>
        <p>Antes de tentar novamente, confirme:</p>
        <ul>
          <li>E1_Connect aberto</li>
          <li>TEFHUB / GP Elgin aberto</li>
          <li>Pinpad conectado ao computador</li>
          <li>Internet funcionando</li>
          <li>Pedido de TEF já liberado pela Elgin</li>
        </ul>

        <strong>Como ativar o TEF (caso ainda não tenha)</strong>
        <ol>
          <li>Solicite o TEF ao Comercial ou ao time de CS da Ultracar.</li>
          <li>
            Peça ao seu banco/adquirente os seguintes dados:
            <ul>
              <li>Número Lógico</li>
              <li>Estabelecimento Comercial</li>
              <li>Chave Pix (opcional)</li>
            </ul>
          </li>
          <li>
            O suporte da Ultracar fará o pedido na Elgin e agendará a
            instalação.
          </li>
          <li>
            A instalação é realizada pela Elgin, com acompanhamento da Ultracar.
          </li>
          <li>
            Após a liberação, conecte o pinpad e realize uma venda de teste.
          </li>
        </ol>

        <strong>Observações importantes</strong>
        <ul>
          <li>Pagamentos via Pix não possuem cancelamento automático.</li>
          <li>
            Para habilitar o Pix no terminal, é necessário ajustar no arquivo de
            configuração:
            <br />
            <code>pix4 = 1</code>
          </li>
        </ul>

        <Divider />

        <strong>Documentação oficial Elgin</strong>
        <p>
          Acesse:{' '}
          <strong>
            <a
              href="https://elgindevelopercommunity.github.io/modules.html"
              target="_blank"
            >
              https://elgindevelopercommunity.github.io/modules.html
            </a>
          </strong>
        </p>

        <strong>Suporte</strong>
        <p>
          Ultracar: dúvidas sobre o uso do TEF no sistema.
          <ul>
            <li>
              <strong>
                <a href={process.env.REACT_APP_SUPPORT_URL}>Suporte Ultracar</a>
              </strong>
            </li>
          </ul>
        </p>
        <p>
          Elgin: instalação, pinpad e programas TEF
          <ul>
            <li>
              WhatsApp oficial:{' '}
              <strong>
                <a target="_blank" href={`https://wa.me/5511998519559`}>
                  +55 11 99851-9559
                </a>
              </strong>
            </li>
          </ul>
        </p>
      </Modal>
    </>
  );
}
